/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { catchError, throwError } from "rxjs";
import { SnackBarService } from './../services/snack-bar.service';
import {  inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { SessionExpiredDialogComponent } from "../components/shared/dialogs/session-expired-dialog/session-expired-dialog.component";


export const authInterceptor: HttpInterceptorFn = (req, next) => {

const router = inject(Router);
const snackBarService = inject(SnackBarService);
const translateService = inject(TranslateService);
const dialog = inject(MatDialog);

const handleSessionExpired = () => {
  sessionStorage.removeItem('token');

  if (dialog.openDialogs.length === 0) {
    dialog.open(SessionExpiredDialogComponent, {
      disableClose: true,
      panelClass: 'custom-dialog-container',
      width: '500px'
    });
  }
}

  return next(req).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {

        const isLoginUrl = router.url === '/login';

        switch (err.status) {

          case 401:
            if (!isLoginUrl) {
              handleSessionExpired();
            }
            break;

          case 405:
            if (err.error.message === "NO_VALID_CREDENTIALS" && isLoginUrl) {
             snackBarService.openSnackBar(translateService.instant('error.NO_VALID_CREDENTIALS'), 'shared.close');
            } else if (!isLoginUrl) {
               handleSessionExpired();
            }
            break;
        }
      } else {
        console.error(err);
      }

      return throwError(() => err);
    })
  );
};
